<template>
  <Page>
    <div class="container container--small page--static">
      <h1>
        {{ $t('static/our-stores-title') }}
      </h1>

      <p class="h-margin-bottom">
        {{ $t('stores/intro-text') }}
      </p>

      <StoreMap
        :stores="stores"
        :initial-zoom="7"
        class="h-hide-tablet-down h-margin-bottom h-margin-top" />

      <btn
        full-width="all"
        :to="{ name: `${$lang}-stores-map`}"
        class="h-hide-tablet-up h-margin-bottom"
        color="cta">
        <svg-icon
          class="h-margin-right-s"
          name="Map/map-pin-2-line" />
        {{ $t('stores/show-stores-on-map') }}
      </btn>
      <h3 class="h-margin-top-l h-margin-bottom">
        {{ $t('stores/directly-to-your-store') }}
      </h3>
      <grid>
        <cell
          v-for="store in stores"
          :key="store.id"
          desktop="6"
          size="12">
          <Card :to="{path: `/${$lang}/stores/${store.slug}`}" border horizontal>
            <template #image>
              <img :src="store.image">
            </template>
            <template #title>
              <b>{{ store.fullTitle }}</b><br>
            </template>
            <div>
              {{ store.address.street + ' ' + store.address.housenr }}
            </div>
            <StoreStatus v-if="store.openingHours" :store-name="store.name" :opening-hours="store.openingHours" :special-opens-at="store.specialOpensAt" class="h-margin-top-s" />
          </Card>
        </cell>
      </grid>
      <div
        class="page__section h-margin-top-l"
        v-html="$t('stores/pick-up-point')" />
      <ServiceBanner class="h-margin-top-xl" />
    </div>
  </Page>
</template>
<script setup>
import {
  formatCanonical,
  formatOpenGraph,
  formatMetaDescription
} from '~/helpers/metadata'

const { $api } = useNuxtApp()

await useI18n([
  'static',
  'openinghours',
  'stores'
])

const { data } = await useAsyncData('stores', async () => {
  const [shops, navigation] = await Promise.all([
    $api('shops'),
    $api('navigation/stores')
  ])

  return { shops, navigation }
})

const stores = computed(() => {
  return data.value.shops
})

const navigation = computed(() => {
  return data.value.navigation
})

const metaData = unref(navigation.value).metaData

useHead({
  title: metaData.pageTitle,
  titleTemplate: '%s',
  link: [...formatCanonical(metaData)],
  meta: [
    ...formatOpenGraph(metaData.openGraph),
    formatMetaDescription(metaData)
  ],
  script: [{ type: 'application/ld+json', innerHTML: metaData.schemaOrg }] // Structured data
})

</script>
